import { css } from '@emotion/css'
import colors from '@styles/colors';
import { mobileOnly } from '@styles/breakpoints';

function tooltip(width?: number, height?: number) {
    return css({
        '.ing-tooltip': {
            position: 'absolute',
            display: 'none',
            WebkitBoxOrient: 'vertical',
            WebkitBoxDirection: 'normal',
            MsFlexDirection: 'column',
            flexDirection: 'column',
            padding: 15,
            marginTop: 10,
            width: width ? width : 235,
            height: height ? height : 'auto',
            backgroundColor: colors.BEIGE_EXTRA_LIGHT,
            border: `1px solid ${colors.BLUE_LIGHT}`,
            WebkitBoxShadow: '0px -2px 8px rgba(21, 32, 107, 0.08)',
            boxShadow: '0px -2px 8px rgba(21, 32, 107, 0.08)',
            borderRadius: 5,
            textAlign: 'left',
            zIndex: 3,

            [mobileOnly]: {
                maxWidth: '70vw',
                left: 0,
            },

            '.title': {
                color: colors.NAVY,
                fontSize: 15,
            },

            '.sub': {
                color: colors.BLUE,
                fontSize: 13,
            },
        },

        '&:hover': {
            '.ing-tooltip': {
                display: 'flex',
            },
        },

        '&.active': {
            cursor: 'pointer',
            '.ing-tooltip': {
                display: 'flex !important',
            },
        },

        '&.inactive': {
            cursor: 'pointer',
            '.ing-tooltip': {
                display: 'none !important',
            },
        }
    })
}

export default {
    tooltip: tooltip,
};
